import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Login } from "./tap/pages/Login";
import { AuthorizedApp } from "auth/AuthorizedApp";
import { AuthProvider } from "auth/AuthProvider";
import { AuthVerify } from "auth/AuthVerify/AuthVerify";
import { resetActiveUser } from "./tap/utils/localStorageService";
import { logout } from "./tap/store/auth";

export function Core() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  async function logOut() {
    resetActiveUser();
    await dispatch(logout());
    navigate("/login");
  }

  return (
    <div id="app" className="d-flex flex-column min-vh-100">
      <AuthProvider LoginComp={Login} AppComp={AuthorizedApp} />
      <AuthVerify logOut={logOut} />
    </div>
  );
}
